import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { DepartmentsFacade } from '@app/store/departments';
import { DivisionsFacade } from '@app/store/divisions';
import { ElementsFacade } from '@app/store/elements';
import { MaterialTypesFacade } from '@app/store/material-types';
import { MaterialsFacade } from '@app/store/materials';
import { ProfileFacade } from '@app/store/profile';
import { RolesFacade } from '@app/store/roles';
import { SessionFacade } from '@app/store/session';
import { StockHistoryFacade } from '@app/store/stock-history';
import { UsersFacade } from '@app/store/users';
import { WarehousesFacade } from '@app/store/warehouses';
import { AccountFacade } from '@corelabs/angular/account';
import { filter, map, tap } from 'rxjs';

export const logout = (): CanActivateFn => {
    return () => {
        const sessionFacade = inject(SessionFacade);
        const profileFacade = inject(ProfileFacade);
        const usersFacade = inject(UsersFacade);
        const rolesFacade = inject(RolesFacade);
        const departmentsFacade = inject(DepartmentsFacade);
        const divisionsFacade = inject(DivisionsFacade);
        const warehousesFacade = inject(WarehousesFacade);
        const materialsFacade = inject(MaterialsFacade);
        const elementsFacade = inject(ElementsFacade);
        const materialTypesFacade = inject(MaterialTypesFacade);
        const stockHistoryFacade = inject(StockHistoryFacade);
        const accountFacade = inject(AccountFacade);

        accountFacade.logout();

        return accountFacade.loggedOut$.pipe(
            filter((loggedOut) => loggedOut !== null),
            tap(() => {
                sessionFacade.clear();
                profileFacade.clear();

                // List data outlives its page, so a revisited list shows its last rows while it refetches; it goes here, on sign-out.
                usersFacade.clear();
                rolesFacade.clear();
                departmentsFacade.clear();
                divisionsFacade.clear();
                warehousesFacade.clear();
                materialsFacade.clear();
                elementsFacade.clear();
                materialTypesFacade.clear();
                stockHistoryFacade.clear();
            }),
            map(() => true),
        );
    };
};
